<template>
  <b-row class="mt-4 mb-2">
    <b-col xl="4">
      <h4>Observable Accounts</h4>
      <p class="small">Observable accounts are accounts that have either Agents given you access or you have added to your Team Users. You have the ability to view and/or edit their ClarityNOW portal.</p>
    </b-col>
    <b-col xl="8">
      <b-row>
        <b-col xl="4" v-for="(user, key) in items" :key="key">
          <b-card no-body>
            <b-card-header>
              <h3 class="mb-0">{{ user.name }}</h3>
            </b-card-header>
            <!-- /.card-header -->
            <b-card-footer>
              <ul class="nav nav-pills nav-sidebar flex-column" role="menu" data-accordion="false" data-widget="treeview">
                <li class="nav-item">
                  <router-link :to="{name: 'observe.dashboard', params: { user: user.slug }}" class="nav-link">
                    <i class="fas fa-tachometer-alt"></i> Dashboard
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{name: 'observe.ceo-summary', params: { user: user.slug }}" class="nav-link">
                    <i class="fas fa-user-tie"></i> CEO Summary
                  </router-link>
                </li>
                <li class="nav-item has-treeview">
                  <a href="#" class="nav-link">
                    <i class="fas fa-tasks"></i> 
                      Business Planning
                      <i class="fas fa-angle-left right"></i>
                  </a>
                  <ul class="nav nav-treeview">
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.economic-model', params: { user: user.slug }}" class="nav-link">
                        Economic Model
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.budget-model', params: { user: user.slug }}" class="nav-link">
                        Budget Model
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.lead-gen-model', params: { user: user.slug }}" class="nav-link">
                        Lead Gen Model
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.goal-gap', params: { user: user.slug }}" class="nav-link">
                        Goal/Gap
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li class="nav-item">
                  <router-link :to="{name: 'observe.daily-items', params: { user: user.slug }}" class="nav-link">
                    <i class="fas fa-list"></i> Daily Items of Value
                  </router-link>
                </li>
                <li class="nav-item has-treeview">
                  <a href="#" class="nav-link">
                    <i class="fas fa-stream"></i> 
                      Pipeline Reports
                      <i class="fas fa-angle-left right"></i>
                  </a>
                  <ul class="nav nav-treeview">
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.pipelines.type', params: { user: user.slug, type: 'listing' }}" class="nav-link">
                        Listing Pipelines
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.pipelines.type', params: { user: user.slug, type: 'buyer' }}" class="nav-link">
                        Buyer Pipelines
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li class="nav-item has-treeview">
                  <a href="#" class="nav-link">
                    <i class="fas fa-home"></i> 
                      Listings
                      <i class="fas fa-angle-left right"></i>
                  </a>
                  <ul class="nav nav-treeview">
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.listings.status', params: { user: user.slug, status: 'coming-soon' }}" class="nav-link">
                        Coming Soon Listings
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.listings.status', params: { user: user.slug, status: 'active' }}" class="nav-link">
                        Active Listings
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.listings.status', params: { user: user.slug, status: 'expired' }}" class="nav-link">
                        Expired Listings
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.listings.status', params: { user: user.slug, status: 'cancelled' }}" class="nav-link">
                        Cancelled Listings
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li class="nav-item has-treeview">
                  <a href="#" class="nav-link">
                    <i class="fas fa-dollar-sign"></i> 
                      Transactions
                      <i class="fas fa-angle-left right"></i>
                  </a>
                  <ul class="nav nav-treeview">
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.transactions.status', params: { user: user.slug, status: 'pending' }}" class="nav-link">
                        Pending Transactions
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.transactions.status', params: { user: user.slug, status: 'closed' }}" class="nav-link">
                        Closed Transactions
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.transactions.status', params: { user: user.slug, status: 'failed' }}" class="nav-link">
                        Failed Transactions
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li class="nav-item has-treeview">
                  <a href="#" class="nav-link">
                    <i class="fas fa-coins"></i> 
                      Financials
                      <i class="fas fa-angle-left right"></i>
                  </a>
                  <ul class="nav nav-treeview">
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.expenses', params: { user: user.slug }}" class="nav-link">
                        Expenses
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link :to="{name: 'observe.profit-loss', params: { user: user.slug }}" class="nav-link">
                        Profit & Loss
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';

export default {
  data: function() {
    return {
      items: null
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    }
  },
  methods: {
    async getItems() {
      axios.get(this.userRoute + "/observable-users")
      .then(response => {
        this.items = response.data;
      });
    }
  },
  created() {
    this.getItems();
  },
};
</script>